import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { STATE_BPWIZARD_GENERAL } from '../../../../shared/app-states';

@Component({
  selector: 'bp-wizard-welcome',
  template: `
    <div *ngIf="profileId">
      <h2><text key="HEADING"></text></h2>
      <text key="CONTENT"></text>
      <button class="btn btn-primary" (click)="next()"><span translate>GA.BUTTONS.NEXT</span> &nbsp;<i class="fa fa-caret-right"></i></button>
    </div>
  `
})
export class BPWizardWelcomeComponent {
  @Input() public profileId:number;

  constructor(
    private stateService:StateService
  ) {
    /**/
  }
  public next():void {
    this.stateService.go(STATE_BPWIZARD_GENERAL, { profileId: this.profileId });
  }
}